import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { SelectivePreloadStrategy } from "./strategies/selective-preload.strategy";
import { PathConstant } from "./constants/path.constant";
import { DefaultLayoutComponent } from "./containers";
import { P404Component } from "./views/error/404.component";
import { P500Component } from "./views/error/500.component";
import { LoginComponent } from "./views/login/login.component";


export const routes: Routes = [
  {
    path: PathConstant.EMPTY,
    component: LoginComponent,
    pathMatch: "full",
  },
  {
    path: "404",
    component: P404Component,
    data: {
      title: "Page 404",
    },
  },
  {
    path: "500",
    component: P500Component,
    data: {
      title: "Page 500",
    },
  },
  {
    path: "login",
    component: LoginComponent,
    data: {
      title: "Login Page",
    },
  },
  {
    path: PathConstant.EMPTY,
    component: DefaultLayoutComponent,
    data: {
      title: "BMS",
    },
    children: [
      {
        path: "staff",
        loadChildren: () =>
          import("./views/staff/staff.module").then((m) => m.StaffModule),
      },
      {
        path: "favourite",
        loadChildren: () =>
          import("./views/favourite/favourite.module").then((m) => m.FavouriteModule),
      },
      {
        path: "customer",
        data: { preload: true },
        loadChildren: () =>
          import("./views/customer/customer.module").then((m) => m.CustomerModule),
      },
      {
        path: "runner",
        loadChildren: () =>
          import("./views/runner/runner.module").then((m) => m.RunnerModule),
      },
      {
        path: "sales",
        data: { preload: true },
        loadChildren: () =>
          import("./views/sales/sales.module").then((m) => m.SalesModule),
      },
      {
        path: "policy",
        data: { preload: true },
        loadChildren: () =>
          import("./views/policy/policy.module").then((m) => m.PolicyModule),
      },
      {
        path: "performance",
        loadChildren: () =>
          import("./views/performance/performance.module").then((m) => m.PerformanceModule),
      },
      {
        path: "staff-performance-new",
        loadChildren: () =>
          import("./views/staff-performance-new/staff-performance-new.module").then((m) => m.StaffPerformanceNewModule),
      },
      {
        path: "road-tax",
        loadChildren: () =>
          import("./views/road-tax/road-tax.module").then((m) => m.RoadTaxModule),
      },
      {
        path: "job",
        loadChildren: () =>
          import("./views/job/job.module").then((m) => m.JobModule),
      },
      {
        path: "invoice",
        loadChildren: () =>
          import("./views/invoice/invoice.module").then((m) => m.InvoiceModule),
      },
      {
        path: "report-summary",
        loadChildren: () =>
          import("./views/report-summary/report-summary.module").then((m) => m.ReportSummaryModule),
      },
      {
        path: "report",
        loadChildren: () =>
          import("./views/report/report.module").then((m) => m.ReportModule),
      },
      {
        path: "report-graph",
        loadChildren: () =>
          import("./views/report-graph/report-graph.module").then((m) => m.ReportGraphModule),
      },
      {
        path: "report-enquiry",
        loadChildren: () =>
          import("./views/report-enquiry/report-enquiry.module").then((m) => m.ReportEnquiryModule),
      },
      {
        path: "report-staff-performance",
        loadChildren: () =>
          import("./views/report-staff/report-staff.module").then((m) => m.ReportStaffModule),
      },
      {
        path: "report-quotation-performance",
        loadChildren: () =>
          import("./views/report-quotation/report-quotation.module").then((m) => m.ReportQuotationModule),
      },
      {
        path: "renewal",
        data: { preload: true },
        loadChildren: () =>
          import("./views/renewal/renewal.module").then((m) => m.RenewalModule),
      },
     {
        path: "renewal-non-motor",
        loadChildren: () =>
          import("./views/renewal-non-motor/renewal-non-motor.module").then((m) => m.RenewalNonMotorModule),
      },
      {
        path: "support",
        loadChildren: () =>
          import("./views/support/support.module").then((m) => m.SupportModule),
      },
      // {
      //   path: "settings",
      //   loadChildren: () =>
      //     import("./views/product/product.module").then((m) => m.ProductModule),
      // },
      {
        path: "settings",
        loadChildren: () =>
          import("./views/insurance/insurance.module").then((m) => m.InsuranceModule),
      },
      {
        path: "settings",
        loadChildren: () =>
          import("./views/payment-gateway/payment-gateway.module").then((m) => m.PaymentGatewayModule),
      },
      {
        path: "settings",
        loadChildren: () =>
          import("./views/settings-road-tax/settings-road-tax.module").then((m) => m.SettingsRoadTaxModule),
      },
      {
        path: "settings",
        loadChildren: () =>
          import("./views/message-template/message-template.module").then((m) => m.MessageTemplateModule),
      },
      {
        path: "settings",
        loadChildren: () =>
          import("./views/settings-commission/settings-commission.module").then((m) => m.SettingsCommissionModule),
      },
      {
        path: "settings",
        loadChildren: () =>
          import("./views/branch/branch.module").then((m) => m.BranchModule),
      },
      {
        path: "settings",
        loadChildren: () =>
          import("./views/account-code/account-code.module").then((m) => m.AccountCodeModule),
      },
      {
        path: "settings",
        loadChildren: () =>
          import("./views/license/license.module").then((m) => m.LicenseModule),
      },
      {
        path: "dashboard",
        data: { preload: true },
        loadChildren: () =>
          import("./views/dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          ),
      },
    ],
  },
  { path: "**", component: P404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: SelectivePreloadStrategy })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
